module.exports = __webpack_public_path__ + "static/people_pop19-0ca69122477e1453dae375c40bde7f8a.png";